import React, { useState, useEffect } from 'react';
import { getAllTenants } from '../utils/adminApi';
import toastr from 'toastr';

const AllTenants = () => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all, self, msp

  useEffect(() => {
    loadTenants();
  }, []);

  const loadTenants = async () => {
    try {
      const tenantsData = await getAllTenants();
      setTenants(tenantsData);
    } catch (error) {
      console.error('Error loading tenants:', error);
      toastr.error('Failed to load tenants');
      setTenants([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredTenants = tenants.filter(tenant => {
    if (filter === 'all') return true;
    if (filter === 'self') return tenant.managedBy === 'self';
    if (filter === 'msp') return tenant.managedBy === 'msp';
    return true;
  });

  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>All Tenants</h2>
        <div className="btn-group">
          <button 
            className={`btn btn-sm ${filter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('all')}
          >
            All ({tenants.length})
          </button>
          <button 
            className={`btn btn-sm ${filter === 'self' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('self')}
          >
            Self-Managed ({tenants.filter(t => t.managedBy === 'self').length})
          </button>
          <button 
            className={`btn btn-sm ${filter === 'msp' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setFilter('msp')}
          >
            MSP-Managed ({tenants.filter(t => t.managedBy === 'msp').length})
          </button>
        </div>
      </div>

      {filteredTenants.length === 0 ? (
        <div className="alert alert-info">
          <strong>No tenants found.</strong>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>Email</th>
                <th>Tenant ID</th>
                <th>Management</th>
                <th>MSP</th>
                <th>Plan</th>
                <th>AWS Accounts</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {filteredTenants.map(tenant => (
                <tr key={tenant.tenantID}>
                  <td>{tenant.email}</td>
                  <td><code className="small">{tenant.tenantID}</code></td>
                  <td>
                    <span className={`badge ${tenant.managedBy === 'msp' ? 'bg-warning' : 'bg-info'}`}>
                      {tenant.managedBy}
                    </span>
                  </td>
                  <td>
                    {tenant.mspID ? (
                      <code className="small">{tenant.mspID}</code>
                    ) : (
                      <span className="text-muted">-</span>
                    )}
                  </td>
                  <td>
                    <span className="badge bg-secondary">
                      {tenant.subscriptionPlan?.plan || 'Basic'}
                    </span>
                  </td>
                  <td>
                    {tenant.cloudAccounts?.aws?.length || 0} AWS
                    {tenant.cloudAccounts?.organizations?.length > 0 && 
                      ` + ${tenant.cloudAccounts.organizations.length} Org`
                    }
                  </td>
                  <td>
                    {tenant.createdAt ? new Date(tenant.createdAt).toLocaleDateString() : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AllTenants;
